import React from 'react';

import { Block, Menu } from '@uncinc/react-drupal-core';

import { MenuItem, MenuTree } from '@uncinc/react-drupal-core/types';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { Footer } from '../../../components';
import { APP_OPTIONS } from '../../../config/constants';

const FOOTER_MENU_ID = 'footer';
const FOOTER_SECONDARY_MENU_ID = 'footersecondary';

const FooterMenu: React.FC = () => {
  return (
    <Footer>
      <Container>
        <Footer.Logo />
        <Menu id={FOOTER_MENU_ID}>
          {(items: MenuTree<MenuItem[]>) => {
            const menu = items.toJS();

            return (
              <nav>
                <Footer.Row>
                  { menu.map((topLevelMenuItem) => {
                    const normalizedTitle = topLevelMenuItem.link.title.toLowerCase().replace(/ /g, '-');
                    const listItems = topLevelMenuItem.subtree.map((item) => {
                      return {
                        title: item.link.title,
                        href: item.link.url,
                        className: item.link.options?.attributes?.class?.join(' '),
                      };
                    });

                    return (
                      <Footer.Column
                        key={`footer-${normalizedTitle}`}
                        heading={topLevelMenuItem.link.title}
                        headingId={normalizedTitle}
                      >
                        <Footer.LinkList
                          ariaLabelledBy={normalizedTitle}
                        >
                          {listItems.map((item) => {
                            return (
                              <Footer.LinkList.Item
                                key={`link-list-${item.href}`}
                                title={item.title}
                                href={item.href}
                                className={item.className}
                              />
                            );
                          })}
                        </Footer.LinkList>
                      </Footer.Column>
                    );
                  })}
                  <Footer.Column>
                    <Block id={String(APP_OPTIONS.parameters.footerCtaBlockId)} />
                  </Footer.Column>
                </Footer.Row>
              </nav>
            );
          }}
        </Menu>
        <Footer.Border />
        <Menu id={FOOTER_SECONDARY_MENU_ID}>
          {(items: MenuTree<MenuItem[]>) => {
            const listItems = items.toJS().map((item) => {
              return {
                title: item.link.title,
                href: item.link.url,
                className: item.link.options?.attributes?.class?.join(' '),
              };
            });

            return (
              <Footer.LinkList direction="column">
                {listItems.map((item) => {
                  return (
                    <Footer.LinkList.Item
                      key={`link-list-${item.href}`}
                      title={item.title}
                      href={item.href}
                      className={item.className}
                    />
                  );
                })}
              </Footer.LinkList>
            );
          }}
        </Menu>
      </Container>
    </Footer>
  );
};


export default FooterMenu;
